
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventos/[slug]",
      function () {
        return require("private-next-pages/eventos/[slug]/index.js");
      }
    ]);
  